import { useState } from 'react';
import * as THREE from 'three';
import { QueueLineModel } from '../types';

interface UseSelectionStateReturn {
  selectedMeshesForUI: THREE.Mesh[];
  setSelectedMeshesForUI: React.Dispatch<React.SetStateAction<THREE.Mesh[]>>;
  activeTextMesh: THREE.Mesh | null;
  setActiveTextMesh: React.Dispatch<React.SetStateAction<THREE.Mesh | null>>;
  selectedQueueLine: QueueLineModel | null;
  setSelectedQueueLine: React.Dispatch<
    React.SetStateAction<QueueLineModel | null>
  >;
  overlappingShoppers: string[];
  setOverlappingShoppers: React.Dispatch<React.SetStateAction<string[]>>;
}

export const useSelectionState = (): UseSelectionStateReturn => {
  const [selectedMeshesForUI, setSelectedMeshesForUI] = useState<THREE.Mesh[]>(
    []
  );
  const [activeTextMesh, setActiveTextMesh] = useState<THREE.Mesh | null>(null);
  const [selectedQueueLine, setSelectedQueueLine] =
    useState<QueueLineModel | null>(null);
  const [overlappingShoppers, setOverlappingShoppers] = useState<string[]>([]);

  return {
    selectedMeshesForUI,
    setSelectedMeshesForUI,
    activeTextMesh,
    setActiveTextMesh,
    selectedQueueLine,
    setSelectedQueueLine,
    overlappingShoppers,
    setOverlappingShoppers,
  };
};
